// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_3-3";
export var dialog = "_3-0";
export var divClassnameSwatch = "_3-8";
export var flexSwatch = "_3-4";
export var header = "_3-1";
export var styleAttributeSwatch = "_3-7";
export var swatch = "_3-2";
export var textHeaderSwatch = "_3-5";
export var webSwatch = "_3-6";